<template>
  <!-- A link to a help center guide, opened in a new tab so nothing in the app is left. `path` is the guide under /help-center/ (an anchor is fine). -->
  <a :href="`/help-center/${path}`" target="_blank" rel="noopener noreferrer" data-turbo="false" :title="title || `Open the guide: ${label}`"
    class="inline-flex items-center gap-1 text-xs font-semibold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/50 rounded">
    <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"/>
    </svg>
    <span>{{ label }}</span>
  </a>
</template>

<script setup>
defineProps({
  path: { type: String, required: true }, // e.g. 'job-tracker/fetch-jobs' or 'job-tracker/turn-on-ai#cost'
  label: { type: String, default: 'Guide' },
  title: { type: String, default: '' },
})
</script>
